import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import InvoicesNavigationIcon from 'Icons/NavigationItem/Invoices';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyInvoicesSettingsPage = React.lazy(() => import('./Pages'));

const invoicesSettingsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.invoices.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.invoices.title',
            url: '/invoices-settings',
            Icon: InvoicesNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyInvoicesSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default invoicesSettingsConfiguration;
